module.exports = __webpack_public_path__ + "img/eae6df5.svg";